// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const TooltipHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="14"
            height="15"
            fill="currentColor"
        >
            <path
                d="M169,951.75 C165.133594,951.75 162,954.883594 162,958.75 C162,962.616406 165.133594,965.75 169,965.75 C172.866406,965.75 176,962.616406 176,958.75 C176,954.883594 172.866406,951.75 169,951.75 Z M169,962.6875 C168.507812,962.6875 168.125,962.304688 168.125,961.8125 C168.125,961.320312 168.483203,960.9375 169,960.9375 C169.467578,960.9375 169.875,961.320312 169.875,961.8125 C169.875,962.304688 169.467578,962.6875 169,962.6875 Z M170.889453,958.804688 L169.65625,959.570312 L169.65625,959.625 C169.65625,959.980469 169.355469,960.28125 169,960.28125 C168.644531,960.28125 168.34375,959.980469 168.34375,959.625 L168.34375,959.1875 C168.34375,958.96875 168.453125,958.75 168.671875,958.613281 L170.230469,957.683594 C170.421875,957.574219 170.53125,957.382812 170.53125,957.164062 C170.53125,956.835938 170.233203,956.5625 169.905078,956.5625 L168.507812,956.5625 C168.155078,956.5625 167.90625,956.835938 167.90625,957.164062 C167.90625,957.519531 167.605469,957.820312 167.25,957.820312 C166.894531,957.820312 166.59375,957.519531 166.59375,957.164062 C166.59375,956.097656 167.441406,955.25 168.483203,955.25 L169.880469,955.25 C170.996094,955.25 171.84375,956.097656 171.84375,957.164062 C171.84375,957.820312 171.488281,958.449219 170.889453,958.804688 Z"
                transform="translate(-162 -951)"
            />
        </svg>
    );
};

export default React.memo(TooltipHover);
